<template>
  <div class="createPostBtnWrapper">
    <v-container>
      <v-row class="mt-2">
        <v-col cols="12" md="3" lg="auto">
          <div class="mb-3">
            <v-btn
              block
              depressed
              color="primary"
              class="text-none btn subtitle-2 v-size--large"
              @click="isOpenDialog()"
            >
              <span v-translate>Start a Discussion</span>
            </v-btn>
          </div>
          <div>
            <v-btn
              v-if="tagFilter || languageFilter"
              class="mb-2" block color="red"
              outlined small
              @click="removeAllFilters()"
            >
              <v-icon class="fal fa-xmark mr-3" size="15"></v-icon>
              <translate>Remove all filter</translate>
            </v-btn>
            <div class="d-flex align-center mt-6">
              <v-icon size="18" class="mr-3" color="primary">
                fas fa-language
              </v-icon>
              <translate>Languages</translate>
            </div>
            <div class="languageCapitalize">
              <v-radio-group v-model="languageFilter" class="mt-1">
                <v-radio
                  v-for="lang in languages"
                  :key="lang.id"
                  color="primary"
                  :value="lang.id"
                  :label="`${lang.name} (${lang.count})`"
                ></v-radio>
              </v-radio-group>
            </div>
            <div class="d-flex align-center mt-2">
              <v-icon size="18" class="mr-3" color="primary">
                fas fa-tag
              </v-icon>
              <translate>Tags</translate>
            </div>
            <div>
              <v-radio-group v-model="tagFilter" class="mt-1">
                <v-radio
                  v-for="(val, key) in tags"
                  :key="key"
                  color="primary"
                  :value="val.name"
                  :label="`${val.name} (${val.counter})`"
                  hide-details
                ></v-radio>
              </v-radio-group>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="6" lg="8">
          <v-row dense align="center" class="mb-3">
            <v-col cols="12" :sm="6" :md="4">
              <v-select
                solo
                dense
                outlined
                flat
                v-model="sortBy"
                :items="sortByItems"
                item-text="name"
                item-value="value"
                hide-details
                return-object
              ></v-select>
            </v-col>

            <v-col cols="12">
              <v-list class="mt-3 py-0" three-line>
                <template v-for="(item, index) in posts">
                  <v-list-item
                    :key="index"
                    class="px-md-8 px-2 pointer"
                    style="border-bottom: 1px solid #e0e0e0"
                    @click="
                      $router
                        .push({ path: `/community/${item.id}` })
                        .catch((err) => {})
                    "
                  >
                    <v-list-item-avatar>
                      <v-img
                        :src="avatarUrl(item.profile.picture)"
                      ></v-img>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <h4 class="mb-1">
                        <b class="primary--text">
                          {{ item.title || $gettext("The Title Empty") }}
                        </b>
                      </h4>
                      <div class="caption grey--text">
                        {{ item.createdDate | ago }}
                      </div>
                      <div
                        class="subtitle-2-thin mb-1 same-size"
                        v-html="item.content"
                      ></div>
                      <div>
                        <template v-if="item.hashtags">
                          <span
                            class="accent--text ml-1"
                            v-for="(val, key) in item.hashtags"
                            :key="key"
                          >
                            #{{ val }}
                          </span>
                        </template>
                      </div>
                    </v-list-item-content>

                    <div class="subtitle-2 pl-6">
                      <v-icon size="18" class="mr-1 pb-1"
                        >fal fa-comments</v-icon
                      >
                      {{ item.totalComment }}
                    </div>
                  </v-list-item>
                </template>
              </v-list>

              <InfiniteLoad
                v-if="reInit"
                @loading="loadDiscussions()"
                :disabled="endData"
                :pageBegin="currentPage"
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="3" lg="2"></v-col>
      </v-row>
    </v-container>
    <ModifyPost
      ref="dialogModifyPost"
      @postCreated="handlePostCreated"
      :postType="POST_TYPE_DISCUSSION"
    />
  </div>
</template>

<script>
import PostService from "@/services/PostService";
import DiscussionPost from "@/components/Post/Discussion/Post";
import ModifyPost from "@/components/Post/ModifyPost.vue";
import InfiniteLoad from "@/components/InfiniteLoad/InfiniteLoad";

export default {
  components: {
    InfiniteLoad,
    DiscussionPost,
    ModifyPost,
  },
  name: 'Community',
  data() {
    return {
      reInit: false,
      endData: false,
      sortBy: LATEST_DISCUSSION,
      sortByItems: [
        {
          name: this.$gettext("Latest Discussion"),
          value: LATEST_DISCUSSION
        },
        {
          name: this.$gettext("Most Commented"),
          value: MOST_COMMENT
        }
      ],
      currentPage: 1,
      posts: [],
      tags: [],
      tagFilter: null,
      languageFilter: null,
      languages: [],
      currentFilter: {
        tagFilter: null,
        languageFilter: null
      }
    };
  },
  computed: {
    token() {
      return this.$store.state.auth.token
    }
  },
  watch: {
    async sortBy(val) {
      this.resetFilter();
      this.loadDiscussions();
    },
    tagFilter(val) {
      if(val && val == this.currentFilter.tagFilter) {
        return
      }
      if(!val) {
        if(this.currentFilter.tagFilter) {
          this.tagFilter = this.currentFilter.tagFilter
        }
        return
      }
      this.resetFilter();
      this.loadDiscussions();
    },
    languageFilter(val) {
      console.log('lang changed', val)
      if(val && val == this.currentFilter.languageFilter) {
        console.log('lang equal current filter', this.currentFilter.languageFilter)
        return
      }
      if(!val) {
        console.log('lang is null')
        if(this.currentFilter.languageFilter) {
          console.log('lang filter is not null')
          this.languageFilter = this.currentFilter.languageFilter
        }
        return
      }
      console.log('lang filter setted, do filter')
      this.resetFilter();
      this.loadDiscussions();
    }
  },
  methods: {
    async loadDiscussions() {
      const filters =  this.buildFilters()
      const result = await PostService.getDiscussions(filters);
      if (result.error) return
      if (result.totalPages <= this.currentPage) {
        this.endData = true;
      }
      this.posts = this.posts.concat(result.list);
      if(this.currentPage == 1) {
        this.tags = result.tags
        this.languages = result.languages
        console.log('re add filter')
        console.log(filters['filter_language'])
        console.log(this.languageFilter)
        if(filters['filter_language']) {
          this.currentFilter.languageFilter = filters['filter_language']
        }
        if(filters['has_tags_name']) {
          this.currentFilter.tagFilter = filters['has_tags_name']
        }
        this.reInit = true
      }
      this.currentPage++;
    },
    buildFilters() {
      const filters = {
        page: this.currentPage,
        limit: 5,
        filter_type: POST_TYPE_DISCUSSION
      }
      if(this.sortBy) {
        filters['sort_desc'] = this.sortBy.value || this.sortBy
      }
      if(this.tagFilter) {
        filters['has_tags_name'] = this.tagFilter
      }
      if(this.languageFilter) {
        filters['filter_language'] = this.languageFilter
      }
      return filters
    },
    resetFilter() {
      this.reInit = false;
      this.endData = false;
      this.posts = [];
      this.currentPage = 1;
    },
    removeAllFilters() {
      this.tagFilter = null
      this.languageFilter = null
      this.currentFilter = {
        tagFilter: null,
        languageFilter: null
      }
      this.resetFilter();
      this.loadDiscussions();
    },
    async isOpenDialog() {
      if (!this.token) {
        const toggle = await this.$store.state.toggle.dialogConfirm.open(
          this.$gettext("Warning"),
          this.$gettext('You need to login'),
          { color: "warning" }
        );
        if (!toggle) return
        this.$router.push({name: 'login'})
      } else {
        this.$refs.dialogModifyPost.isOpenDialog = true;
      }
    },
    handlePostCreated(post) {
      this.resetFilter();
      this.loadDiscussions();
    },
  },
  async mounted() {
    await this.loadDiscussions();
  },
};
</script>